import { useState as u, useEffect as l } from "react";
const m = (n) => {
  const [i, o] = u({
    width: null,
    height: null
  });
  return l(() => {
    const e = n.current, t = () => {
      if (e) {
        const { width: r, height: c } = e.getBoundingClientRect();
        o({ width: r, height: c });
      }
    };
    t();
    const s = new ResizeObserver(t);
    return e && s.observe(e), () => {
      e && s.unobserve(e);
    };
  }, [n]), i;
};
export {
  m as useElementDimensions
};
